<div id="tp-lg-container" class="prevent-select">
    <div id="lg-labels">
        <div *ngFor="let d of data;">
            {{ d.label | translate | uppercase }}
        </div>
    </div>
    <div id="lg-gauges">
        <div class="gauge-wrapper" *ngFor="let d of data;">
            <div class="gauge-track" [style.background-color]="d.trackColor" >
                <div class="gauge-bar" [style.background-color]="d.barColor" [style.max-width.%]="(d.value / totalCount) * 100">

                </div>
            </div>
        </div>
    </div>
    <div id="lg-values" >
        <div class="lg-value" *ngFor="let d of data;">
            {{d.value}}
        </div>
    </div>
</div>
